import React from 'react';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';

const DetailsHeader = ({ left = null, right = null }) => (
  <Box
    sx={{
      height: '48px',
      pl: 1,
      backgroundColor: (theme) =>
        left ? theme.palette.secondary.light : theme.palette.background.color,
      display: 'flex',
      alignItems: 'center',
      boxShadow:
        '0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)',
    }}
  >
    <Box
      sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '4fr 2fr',
        gridTemplateRows: 1,
        padding: 0,
        gap: '5px',
      }}
    >
      <Box
        sx={{
          color: (theme) => theme.palette.primary.main,
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
        }}
      >
        {left}
      </Box>
      <Box
        sx={{
          color: (theme) => theme.palette.primary.main,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row-reverse',
        }}
      >
        {right}
      </Box>
    </Box>
  </Box>
);

DetailsHeader.defaultProps = { right: null };

DetailsHeader.propTypes = {
  left: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  right: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default DetailsHeader;
